import React, { useState } from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import SponsorshipTiers from './sponsorship/SponsorshipTiers';
import SponsorshipFormSection from './sponsorship/SponsorshipFormSection';
import PartnersAndBenefits from './sponsorship/PartnersAndBenefits';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const INITIAL_FORM = {
  businessName: '',
  contactName: '',
  email: '',
  phone: '',
  selectedTier: '',
  message: '',
};

const scrollToForm = () => {
  document.getElementById('sponsor-form')?.scrollIntoView({ behavior: 'smooth' });
};

const SponsorshipPage = () => {
  const [formData, setFormData] = useState(INITIAL_FORM);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSelectTier = (tierName) => {
    setFormData((prev) => ({ ...prev, selectedTier: tierName }));
    scrollToForm();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_URL}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: `${formData.businessName} - ${formData.contactName}`,
          email: formData.email,
          phone: formData.phone,
          subject: `Sponsorship Inquiry - ${formData.selectedTier}`,
          message:
            formData.message ||
            'Interested in sponsoring Randallstown Youth Football & Cheer.',
        }),
      });
      const data = await response.json();
      if (data.success) {
        setSubmitted(true);
      } else {
        setError('Failed to submit. Please try again.');
      }
    } catch {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <Navigation />

      <main className="main-content">
        <section className="page-hero sponsorship-hero">
          <div className="container">
            <h1 className="page-title">Become a Sponsor</h1>
            <p className="page-subtitle">
              Support youth athletics in our community and get your business recognized
            </p>
          </div>
        </section>

        <section className="sponsorship-about">
          <div className="container">
            <div className="about-content">
              <h2>Why Sponsor the Panthers?</h2>
              <p>
                For over <strong>45 years</strong>, Randallstown Youth Football &amp; Cheer
                Organization has been building champions on and off the field. As a member of the
                Liberty Road Recreation and Parks Council and Baltimore County Department of
                Recreation and Parks, we serve youth ages <strong>5 to 14</strong> with programs
                in tackle football, flag football, and cheerleading.
              </p>
              <p>
                Youth sports are equipment intensive — helmets, shoulder pads, cheer mats, and
                uniforms. The estimated cost to equip just one team is
                {' '}<strong>$3,500 - $5,000</strong>. Your sponsorship helps keep our program
                accessible and affordable for all families while promoting your business to our
                community.
              </p>
              <div className="sponsor-stats">
                <div className="stat-item">
                  <span className="stat-number">45+</span>
                  <span className="stat-label">Years Serving Youth</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">200+</span>
                  <span className="stat-label">Athletes Each Season</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">5-14</span>
                  <span className="stat-label">Age Range</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <SponsorshipTiers onSelectTier={handleSelectTier} />

        <SponsorshipFormSection
          formData={formData}
          onChange={handleChange}
          onSubmit={handleSubmit}
          loading={loading}
          error={error}
          submitted={submitted}
          onReset={() => setSubmitted(false)}
        />

        <PartnersAndBenefits onScrollToForm={scrollToForm} />
      </main>

      <Footer />
    </div>
  );
};

export default SponsorshipPage;
